import { json } from "react-router-dom";
import { authenticatedRedirect } from "../../../../../../common/api/decimal/methods/user";
import { deviceCheck } from "../../../../../../common/utils/browser";
import { DeweySchema } from "../../../../../root/helpers/brandSchema.ts";

export async function getlaunchAppUrl(protocol: string) {
  const redirect = await authenticatedRedirect(protocol);
  if (redirect.ok) {
    return redirect.data?.redirectUri;
  } else {
    throw json(
      { message: "redirectAction not ok" },
      { status: redirect.status }
    );
  }
}

export function getDownloadAppUrl(brand: DeweySchema) {
  const device = deviceCheck();
  if (device) {
    return brand.DownloadOffline[`${device}_url`];
  } else {
    return brand.DownloadOffline.url;
  }
}
